import { render, staticRenderFns } from "./formShow.vue?vue&type=template&id=4cb37368"
import script from "./formShow.vue?vue&type=script&lang=js"
export * from "./formShow.vue?vue&type=script&lang=js"
import style0 from "./formShow.vue?vue&type=style&index=0&id=4cb37368&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports